import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import {Link} from 'react-router-dom';
import AurSvgIcon from '../aur-svg-icon/AurSvgIcon';
import {UrlPathEnums} from '../../../utils/enumUtils';
import {useAnalytics} from '../../../hooks/useAnalytics';
import {
  GA_CLICK_TYPES,
  GA_EVENT_NAMES,
  GA_REGIONS,
} from '../../../constants/analyticsConstants';

interface AurEcaBannerProps {
  className?: string;
  nlpBackLabel?: string;
  onClick?: () => void;
  enableNavigation?: boolean;
  bannerText?: string;
  betaTagText?: string;
}

const AurEcaBanner: React.FC<AurEcaBannerProps> = ({
  className = '',
  nlpBackLabel = '',
  onClick,
  enableNavigation = true,
  bannerText,
  betaTagText,
}) => {
  const {trackGAEvent} = useAnalytics();

  const renderBanner = () => {
    return (
      <Box className={'banner-container'}>
        <span className="beta-chip">
          <AurSvgIcon src="images/sparkle.svg" ariaHidden={true} />
          <Typography component="span" className="typo-text label3_size">
            {betaTagText ?? t('indexSearchPage.beta')}
          </Typography>
        </span>
        <div className="investigation-search">
          <Typography component="span" className="typo-text label1_size">
            {bannerText ?? t('indexSearchPage.exploreWithInvestigativeSearch')}
          </Typography>
          {enableNavigation && <AurSvgIcon src="images/chev_right.svg" ariaHidden={true} />}
        </div>
      </Box>
    );
  };
  return (
    <div className={`eca-banner ${className}`}>
      {enableNavigation ? (
        <Link
          to={UrlPathEnums.NlpSearch}
        onClick={() => {
          trackGAEvent({
            eventName: GA_EVENT_NAMES.CLICK,
            click: {
              name: t('gaTracking.ecaHomePage.exploreWithAiInvestigate'),
              type: GA_CLICK_TYPES.ICON,
              region: GA_REGIONS.TOP_NAV,
              action: t('gaTracking.ecaHomePage.aiInvestigate'),
            },
          });
          onClick?.();
        }}
          state={{from: window.location.pathname, backLabel: nlpBackLabel}}
          data-testid={'explore-link'}
          className="banner-link"
        >
          {renderBanner()}
        </Link>
      ) : (
        <div className="banner-link">{renderBanner()}</div>
      )}
    </div>
  );
};

export default AurEcaBanner;
